import type { GADataProps } from "@typings/GA";
import type { MetaTagsProps } from "@typings/MetaTags";
import type { PageMetaDataValues } from "@typings/PageMetaData";

export default function SearchMetaData(
  searchedText: string,
): PageMetaDataValues {
  const sectionName = "miscellaneous";
  const metaTitle = `Search for "${searchedText}" - Beritaharian`;

  const metaTags: MetaTagsProps = {
    title: metaTitle,
    slug: `/search/site/${encodeURIComponent(searchedText)}`,
  };

  const gaData: GADataProps = {
    level2: sectionName,
    section: sectionName,
    contentcat: "1",
    contenttype: "listing",
  };

  return {
    gaData,
    metaTags,
  };
}
